import {useState} from "react";
import IconClosePng from "../../data/Icons/leon-inmobiliaria-icons-close.png";
import Button from "../common/Button";
import MobileFilterMenuItem from "./MobileFilterMenuItem";
import IconArrowDown from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {ReactElement} from "react-markdown/lib/react-markdown";
import {useTranslation} from "next-i18next";
import Image from "next/image";

export interface MobileFilterMenuItem {
	label: string;
	type: "checkbox" | "radio";
	options?: string[];
	handler: "dropdown" | "checklist";
}

interface MobileFilterMenuPropsFilter {
	items: {
		[key: string]: { label: string; selected: string[]; menu: ReactElement };
	};
	open: boolean;
	onClose: () => void;
	onSearchChange: (searchVal: string) => void;
	onResetFilter: () => void;
	defaultOpenedItemKey?: string;
}

export default function MobileFilterMenu(props: MobileFilterMenuPropsFilter) {
	const {t} = useTranslation();
	const [openedItemKey, setOpenedItemKey] = useState(
		props.defaultOpenedItemKey
	);
	const openedItem = Object.entries(props.items).find(
		([key, item]) => key === openedItemKey
	)?.[1];

	return (
		<div
			className={`bg-leo-light-gray w-screen h-full xl:hidden flex-col fixed top-0 z-20 ${
				props.open ? "flex" : "hidden"
			}`}
		>
			<div className="bg-white flex justify-between h-14 relative top-0 w-full items-center px-6">
				{openedItem ? (
					<div className="flex gap-10 items-center">
						<button
							className="w-3.5 h-3.5"
							onClick={() => setOpenedItemKey(undefined)}
						>
							<IconArrowDown className="rotate-90"/>
						</button>
						<div className="text-leo-button-gray">
							{t(openedItem.label)} {t("components.mobileFilterMenu.filter")}
						</div>
					</div>
				) : (
					<>
						<button className="text-leo-orange" onClick={props.onResetFilter}>
							{t("components.mobileFilterMenu.reset")}
						</button>
						<button
							className="text-leo-button-gray w-5 h-5"
							onClick={props.onClose}
						>
							{/* <IconClose /> */}
							<Image src={IconClosePng} alt="icon close" quality={100}/>
						</button>
					</>
				)}
			</div>
			{openedItem ? (
				<div className="relative grow w-full">
					<div className="px-6 overflow-scroll absolute w-full max-h-[100%]">
						{openedItem.menu}
					</div>
				</div>
			) : (
				<>
					{/* <div className={`mx-6 mt-10`}>
            <SearchField
              title={t("common.searchableFields")}
              onChange={props.onSearchChange}
            />
          </div> */}
					<div className={`mx-6 grow divide-y mt-4`}>
						{Object.entries(props.items).map(([key, item]) => {
							return (
								<div onClick={() => setOpenedItemKey(key)} key={key}>
									<MobileFilterMenuItem
										label={item.label}
										selected={item.selected}
									/>
								</div>
							);
						})}
					</div>
				</>
			)}
			<div className="h-20 bg-white relative bottom-0 px-6 w-full flex items-center justify-center">
				<Button
					onClick={
						openedItem
							? () => {
								setOpenedItemKey(undefined);
							}
							: props.onClose
					}
					minWidth="min-w-full"
					text={openedItem ? t("common.accept") : t("common.show-results")}
					transparent={false}
					border={false}
					bgColor="bg-leo-dark-brown"
				/>
			</div>
		</div>
	);
}
